import "./UserSubscriptions.scss";
import { useState, useEffect } from "react";
import SubscriptionCard from "../../components/SubscriptionCard/SubscriptionCard";
import Loader from "../../components/Loader/Loader";
import api from "../../utils/api";
import { useLanguage } from "../../context/LanguageContext";

const UserSubscriptions = () => {
  const [activeSubscriptions, setActiveSubscriptions] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const { t } = useLanguage();

  useEffect(() => {
    const fetchUserSubscriptions = async () => {
      setIsLoading(true);
      try {
        // Real API call to get user subscriptions
        const response = await api.get("/users/me/subscriptions");

        if (
          response.data &&
          response.data.status === "success" &&
          response.data.data
        ) {
          setActiveSubscriptions(response.data.data);
        } else {
          console.error("Invalid response format:", response);
          setActiveSubscriptions([]);
        }
      } catch (error) {
        console.error("Error fetching subscriptions:", error);
        setActiveSubscriptions([]);
      } finally {
        setIsLoading(false);
      }
    };

    fetchUserSubscriptions();
  }, []);

  return (
    <div className="user-subscriptions-section">
      <div className="container">
        <h2 className="section-title">{t("subscriptions")}</h2>
        <p className="section-description">{t("subscriptionsDescription")}</p>

        {isLoading ? (
          <Loader text={t("loadingSubscriptions")} />
        ) : activeSubscriptions.length > 0 ? (
          <div className="subscriptions-container">
            {activeSubscriptions.map((subscription) => (
              <SubscriptionCard
                key={subscription._id}
                subscription={subscription}
              />
            ))}
          </div>
        ) : (
          <div className="empty-state">
            <div className="empty-icon">📦</div>
            <h3 className="empty-title">{t("noSubscriptions")}</h3>
            <p className="empty-description">
              {t("emptySubscriptionsDescription")}
            </p>
            <button
              className="browse-packages-btn"
              onClick={() => (window.location.href = "/packages")}
            >
              {t("browsePackages")}
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default UserSubscriptions;
